import moment from 'moment'
import 'moment/locale/ru'
import storage from '../common/utils/storage'

const localStorageLng = storage.getValue('lng') ? storage.getValue('lng').split('-')[0] : 'en'

export const getMoment = moment

const defaultDateTimeFormats = {
    en: 'MMM D, YYYY (LT)',
    ru: 'D MMM YYYY (LT)',
}

// Если не приходит параметр указанный напрямую lng - берем из localStorage
export const getDateTime = (timestamp, formats = defaultDateTimeFormats, lng = localStorageLng) => {
    let format = typeof formats === 'string' ? formats : formats[lng]
    return moment(timestamp).locale(lng).format(format)
}

const defaultDateFormats = {
    en: 'MMM D, YYYY',
    ru: 'D MMM YYYY',
}

export const getDate = (timestamp, formats = defaultDateFormats, lng = localStorageLng) => {
    return getDateTime(timestamp, formats, lng)
}

const defaultShortDateFormats = {
    en: 'MMM D',
    ru: 'D MMM',
}

export const getShortDate = (timestamp, formats = defaultShortDateFormats, lng = localStorageLng) => {
    return getDateTime(timestamp, formats, lng)
}

const hour = 60 * 60
const day = hour * 24
const month = day * 30
const year = month * 12

const hourStrRepr = 'HOUR'
const dayStrRepr = 'DAY'
const monthStrRepr = 'MONTH'
const yearStrRepr = 'YEAR'

export const getTime = data => (data && data.getTime()) || new Date.getTime()

export const getTimeStep = (fromDate, toDate, formatAsNumber = true) => {
    const from = moment(fromDate)
    const to = moment(toDate)
    const diff = to.diff(from, 'days')

    if (diff <= 1) return formatAsNumber ? hour : hourStrRepr
    if (diff < 125) return formatAsNumber ? day : dayStrRepr // 125 days
    if (diff < 125 * 30) return formatAsNumber ? month : monthStrRepr // 125 month
    if (diff < 125 * 30 * 12) return formatAsNumber ? year : yearStrRepr // 125 years
    return formatAsNumber ? Math.round((toDate - fromDate) / 6000) : yearStrRepr
}
